/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import {
  isEmptyObject,
  removeEmptyFieldObject,
  useTranslation
} from '@plandi/common'

import { EmptyContent, URLS } from 'src/common'
import { useModelStyles } from 'src/features/models/common/model.styles'
import {
  ProjectCardOwner,
  ProjectCardOwnerSkeleton,
  ProjectMeFilters,
  useProjectsMeFilters,
  useQueryProjectsMe
} from '../common'
import Image from 'next/image'

const useFilters = () => {
  const { categoryId, keyword, sort } = useProjectsMeFilters()

  return { sort, keyword, categoryId }
}

type Props = {
  type: string
}

export const ProjectMeList: React.FC<Props> = ({ type }) => {
  const { data: translate } = useTranslation()
  const classes = useModelStyles()
  const filters = useFilters()
  const isEmptyFilters = isEmptyObject(removeEmptyFieldObject(filters))

  const { data: projectsType, isLoading } = useQueryProjectsMe(filters, type)

  const [projects, setProjects] = useState(projectsType)

  useEffect(() => {
    if (projectsType) setProjects(projectsType)
  }, [projectsType])

  if (isLoading) {
    return (
      <>
        {[...new Array(5)].map((_, i) => (
          <ProjectCardOwnerSkeleton key={i} />
        ))}
      </>
    )
  }

  if ((!projects || !projects?.length) && isEmptyFilters) {
    return (
      <>
        <ProjectMeFilters translate={translate} />
        <div className={classes.noData}>
          <div className={classes.noDataContent}>
            <Image
              width={136}
              height={70}
              src="/shop/assets/noModelIcon.svg"
              alt="noModelIcon"
              className={classes.noModelIcon}
            />
            <EmptyContent
              message={
                translate?.market?.['not-have-my-projects'] ??
                `У вас пока нет проектов, разместите по крайней мере один проект,
                чтоб иметь возможность управлять ими`
              }
              showButton
              buttonProps={{
                text: translate?.shop['add-project'] ?? '',
                href: URLS.projects.create
              }}
            />
          </div>
        </div>
      </>
    )
  }

  if (!projects || !projects?.length) {
    return (
      <>
        <ProjectMeFilters translate={translate} />
        <div className={classes.noData}>
          <div className={classes.noDataContent}>
            <Image
              width={100}
              height={100}
              className={classes.iconNoData}
              src="/shop/assets/noData.svg"
              alt="nodata"
            />
            {translate?.['not-found-data']}
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <ProjectMeFilters translate={translate} />
      {projects?.map((project) => (
        <ProjectCardOwner translate={translate} key={project.id} {...project} />
      ))}
    </>
  )
}
